// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"186":"0b7602d1","638":"7f54661a","694":"f13b9cfa","766":"60b206a7","785":"4a195a4f"}[chunkId] + ".chunk.css";
};